import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ENTERPRISE_CARD_ENABLED } from '../../../constants/ebon';
import { CB, APPLE_PAY, GOOGLE_PAY, PAYPAL } from '../../../constants/paymentMethods';

import Paypal from './payment-choice/Paypal';
import ApplePay from './payment-choice/ApplePay';
import GooglePay from './payment-choice/GooglePay';
import CreditCard from './payment-choice/CreditCard';
import EnterpriseCard from './payment-choice/EnterpriseCard';
import KycMessage from './kyc-message/KycMessage';

import './FunnelPaymentSelectionStepStyle.scss';

const FunnelPaymentSelectionStep = ({
    setPaymentType,
    cartTotalValue,
    kycNeeded,
    i18n,
    ebonPaymentConfig,
    paymentMethods,
    userInfo,
    partnerId
}) => {
    const [selectedMethod, setSelectedMethod] = useState();

    const checkoutAllowed = ebonPaymentConfig.checkoutAllowed && paymentMethods.includes(CB);
    const googlePayAllowed =
        ebonPaymentConfig.googlePayAllowed && paymentMethods.includes(GOOGLE_PAY);
    const applePayAllowed = ebonPaymentConfig.applePayAllowed && paymentMethods.includes(APPLE_PAY);
    const paypalAllowed = ebonPaymentConfig.paypalAllowed && paymentMethods.includes(PAYPAL);

    const handleMethodChange = value => {
        if (selectedMethod !== value) {
            setSelectedMethod(value);
            setPaymentType(value);
        }
    };

    return (
        <div id="payment-selection-container">
            <h3 className="title">{`${i18n.PAYMENT_METHOD}`}</h3>

            {kycNeeded && <KycMessage text={i18n.KYC_MESSAGE} />}

            {ENTERPRISE_CARD_ENABLED && (
                <EnterpriseCard
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                    cartTotalValue={cartTotalValue}
                />
            )}

            {checkoutAllowed && (
                <CreditCard
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                    userInfo={userInfo}
                    partnerId={partnerId}
                />
            )}

            {paypalAllowed && (
                <Paypal selectedMethod={selectedMethod} handleMethodChange={handleMethodChange} />
            )}

            {googlePayAllowed && (
                <GooglePay
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                />
            )}

            {applePayAllowed && (
                <ApplePay selectedMethod={selectedMethod} handleMethodChange={handleMethodChange} />
            )}
        </div>
    );
};

FunnelPaymentSelectionStep.propTypes = {
    cartTotalValue: PropTypes.number,
    kycNeeded: PropTypes.bool,
    userInfo: PropTypes.object,
    partnerId: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig,
        paymentMethods: state.ebon.lock[0].paymentMethods || []
    };
};

export default withRouter(connect(mapStateToProps)(FunnelPaymentSelectionStep));



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/FunnelPaymentSelectionStep.js